import { motion } from 'motion/react'

interface BrandWordProps {
  className?: string
}

export function BrandWord({ className = '' }: BrandWordProps) {
  return (
    <motion.span
      className={`cr-brand-word-live ${className}`.trim()}
      layoutId="cr-brand-word"
      initial={{ opacity: 0, x: -8 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ type: 'spring', stiffness: 260, damping: 24 }}
      whileHover={{ scale: 1.04 }}
    >
      <motion.span
        className="cr-brand-word-grupo"
        animate={{ opacity: [0.82, 1, 0.82] }}
        transition={{ duration: 3.2, repeat: Infinity, ease: 'easeInOut' }}
      >
        Grupo
      </motion.span>{' '}
      <motion.span
        className="hi cr-brand-word-hi"
        animate={{
          textShadow: [
            '0 0 0 rgba(0,217,49,0)',
            '0 0 14px rgba(0,217,49,0.55)',
            '0 0 0 rgba(0,217,49,0)',
          ],
          scale: [1, 1.06, 1],
        }}
        transition={{ duration: 2.6, repeat: Infinity, ease: 'easeInOut' }}
      >
        HI
      </motion.span>
    </motion.span>
  )
}
